export const environment = {
  production: true,
  // bearerToken: "95CfDOvQLWNkQAj3ejv29zXvgzOFZy",
  bearerToken: "CNPLUi5b2kzOHfcJ002gumuxI9qxzD",
  baseBlogUrl: "https://virsablog.wat-s.app/",
  baseUrl: "https://api.virsaindia.com/",
  // baseUrl: "http://192.168.168.156:8000/",
  contentBaseUrl: "/",
  RAZORPAY_KEY_ID: "rzp_live_KoJ1PWQOT79UWL",
  assUrl: "https://d2abnqj5vuy2s4.cloudfront.net/",
  // Indus Labs AI Agent Configuration
  // indusLabsApiKey: "wea0PPeA5lgO9nqMDfb7G-1K6op3uUEJb6G1407ReAs",
  // indusLabsApiBase: "https://api.induslabs.io/api",
  indusLabsAgentId: "AGT_71F83E58",
};
